import axios from 'axios';
import { getAuthTokenUrl } from 'app/services/AuthService/config';
import { removeNotAllowedHeader } from 'shared/api/removeNotAllowedHeader';
import { AccessAuthTokenApi } from './types';

export const accessAuthTokenApi: AccessAuthTokenApi = async params => {
  const authUrl = getAuthTokenUrl();
  const formData = new FormData();

  formData.append('grant_type', params.grantTypeCode);
  formData.append('client_id', params.clientId);
  formData.append('redirect_uri', params.redirectUrl);
  formData.append('code', params.code);
  formData.append('code_verifier', params.verifier);

  const { data } = await axios.post(authUrl, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: false,
    transformRequest: [
      removeNotAllowedHeader('X-CSRFToken'),
      removeNotAllowedHeader('Authorization'),
    ],
  });

  return data;
};
